import vCheckbox from '@/components/form/v-checkbox';

/**
 * Renders a checkbox for display.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @returns {Array}
 */
export default function checkboxColumn({rowData, grid}) {
    const {id} = rowData.fields;
    const vm = grid.$root;

    return [
        vCheckbox,
        {
            class: 'overflow-visible',
            props: {
                selected: grid.selectedRows[id],
                value: true,
                label: null,
            },
            key: id,
            on: {
                input: (value) => {
                    vm.$set(grid.selectedRows, id, value);
                },
            },
        },
    ];
}
